module.exports = __webpack_public_path__ + "img/error.e42d2ab7.svg";